/* @flow */
import gql from 'graphql-tag';
import * as React from 'react';
import { graphql } from 'react-apollo';
import Fieldset from 'components/Fieldset.jsx';
import Legend from 'components/Legend.jsx';
import Text from 'components/Text.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import RoleSelector from 'chat/components/RoleSelector.jsx';
import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';
import Glyph from 'components/Glyph.jsx';
import LinkConstants from 'constants/LinkConstants';

import './RoleSection.scss';

type Props = {
  data: ReactApolloData<MeQuery>,
};

function RoleSection(props: Props) {
  const { loading, me } = props.data;

  if (loading) {
    return <LoadingIndicator />;
  }

  if (!me || !me.role) {
    return <Text>Failed to load user role.</Text>;
  }

  const { role } = me;

  if (!me) {
    return null;
  }

  return (
    <div className="UserProfileView-section RoleSection">
      <Fieldset>
        <Legend>Role</Legend>
        <RoleSelector value={role} disabled />
        <Button disabled>Save</Button>
        <div className="RoleSection-contact-support">
          <Glyph
            color="eclipse"
            name="explanation-circle"
            size="small"
            className="RoleSection-contact-support-icon"
          />
          <Text>
            If you need to change your role, please{' '}
            <Link href={LinkConstants.CONTACT_FORM}>contact support</Link>.
          </Text>
        </div>
      </Fieldset>
    </div>
  );
}

const ME_QUERY = gql`
  query RoleSection {
    me {
      id
      uuid
      role
    }
  }
`;

const withData = graphql(ME_QUERY);

export { RoleSection };
export default withData(RoleSection);
